module.exports = __webpack_public_path__ + "static/2009-boat-141df6daf1e2daa6291aa3a15a66573a.jpg";